module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/超大广角4.a361300b.png";